/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon24Regular = forwardRef('WeatherMoonIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.853 3.002c.282.345.39.85.196 1.325a7.375 7.375 0 0 0 9.622 9.624c.475-.195.98-.086 1.325.196.359.294.576.813.37 1.36A10.003 10.003 0 0 1 12 22c-5.523 0-10-4.477-10-10 0-4.29 2.7-7.947 6.492-9.367a1.197 1.197 0 0 1 1.36.37ZM8.47 4.263a8.5 8.5 0 1 0 11.264 11.265A8.875 8.875 0 0 1 8.471 4.263Z" })));
});
